(function () {
    'use strict';
    /**
     * @description design for common function and data manipulation
     */
    angular.module('mean').factory('commonUtil', ['$filter', '$q', function ($filter, $q) {

        var sortASC_indexArr = (arr) => {
            arr.sort((a, b) => (a.toLowerCase() > b.toLowerCase()) ? 1 : -1);
        }
        return {
            sortASC_indexArr: sortASC_indexArr
        };
    }
    ]);
})();



// WEBPACK FOOTER //
// ./commonUtil/commonUtil.js